import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useApi, fmtTime } from "../../lib/api";
import { SCAN_TYPES } from "../../lib/constants";
import { PageHeader, Empty } from "../../components/common";

const loc = (s) => (s.location ? <a className="underline" target="_blank" rel="noreferrer" href={`https://maps.google.com/?q=${s.location.lat},${s.location.lng}`}>{s.location.lat.toFixed(3)}, {s.location.lng.toFixed(3)}</a> : s.approx_country || "—");

export default function Scans() {
  const { group } = useOutletContext();
  const api = useApi();
  const [type, setType] = useState("");
  const [scans, setScans] = useState(null);
  useEffect(() => { api.get(`/groups/${group.id}/scans`, { params: { type, limit: 300 } }).then((r) => setScans(r.data)); }, [api, group.id, type]);
  return (
    <div data-testid="scans-page">
      <PageHeader overline="Every view and scan" title="Scan log" />
      <div className="flex flex-wrap gap-2 mb-4">
        {[["", "All"], ...Object.entries(SCAN_TYPES).filter(([k]) => !["front_desk", "nurse"].includes(group.my_role) || ["checkin", "checkout"].includes(k))].map(([k, v]) => <button key={k || "all"} data-testid={`scan-filter-${k || "all"}`} onClick={() => setType(k)}
          className={`text-xs px-3 py-1 rounded-full border transition-colors ${type === k ? "border-[var(--group)] text-white" : "border-slate-700 text-slate-400"}`}>{v}</button>)}
      </div>
      {scans && scans.length === 0 ? <Empty testid="scans-empty">No scans yet.</Empty> : (
        <div className="panel p-5 overflow-x-auto"><table className="w-full text-sm" data-testid="scans-table">
          <thead><tr className="text-left overline border-b border-slate-700"><th className="pb-2 pr-4">Time</th><th className="pb-2 pr-4">Type</th><th className="pb-2 pr-4">Person</th><th className="pb-2 pr-4">Tag</th><th className="pb-2 pr-4">Source</th><th className="pb-2">Approx. location</th></tr></thead>
          <tbody>{(scans || []).map((s) => (
            <tr key={s.id} className={`border-b border-slate-800 ${s.is_bot ? "opacity-50" : ""}`} data-testid={`scan-row-${s.id}`}>
              <td className="py-2 pr-4 whitespace-nowrap">{fmtTime(s.ts)}</td>
              <td className="py-2 pr-4">{SCAN_TYPES[s.type] || s.type}{s.is_bot && <span className="ml-2 text-[10px] rounded bg-slate-700 px-1.5 py-0.5" data-testid="bot-filtered-badge">bot filtered</span>}</td>
              <td className="py-2 pr-4">{s.person_name || "—"}</td><td className="py-2 pr-4 font-mono text-xs">{s.bs_id}</td>
              <td className="py-2 pr-4 text-slate-400">{s.source}</td><td className="py-2 text-slate-400">{loc(s)}</td>
            </tr>))}</tbody></table></div>)}
    </div>
  );
}
